var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.83105 31.1673C4.83105 25.6848 10.2852 21.2507 17.0002 21.2507C18.3602 21.2507 19.6777 21.4348 20.9102 21.7748M27.611 25.4723H23.3894M25.5002 23.404V27.6398M24.0835 9.91732C24.0835 13.8293 20.9122 17.0007 17.0002 17.0007C13.0882 17.0007 9.91688 13.8293 9.91688 9.91732C9.91688 6.0053 13.0882 2.83398 17.0002 2.83398C20.9122 2.83398 24.0835 6.0053 24.0835 9.91732ZM31.1669 25.5007C31.1669 25.954 31.1102 26.3931 30.9969 26.8181C30.8694 27.3848 30.6427 27.9373 30.3452 28.419C29.3677 30.0623 27.5685 31.1673 25.5002 31.1673C24.041 31.1673 22.7235 30.6148 21.7319 29.7081C21.3069 29.3398 20.9385 28.9006 20.6552 28.419C20.131 27.569 19.8335 26.5632 19.8335 25.5007C19.8335 23.9707 20.4427 22.5682 21.4344 21.5482C22.4686 20.4857 23.9135 19.834 25.5002 19.834C27.1719 19.834 28.6877 20.5565 29.7077 21.7182C30.6144 22.724 31.1669 24.0557 31.1669 25.5007Z",
    stroke: "#005B98",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserAdd);
export default __webpack_public_path__ + "static/media/user-add.e45cdeb021b88262582ee5f33ec525e6.svg";
export { ForwardRef as ReactComponent };